import { issuesSlice } from './slice';

export * from './deleteRedeliveryStop';
export * from './createRedeliveryStops';
export * from './escalateStopsToProvider';
export * from './state';

const { reducer, actions } = issuesSlice;
export const {
  setSelectAllFilter,
  setDisplayInTransitStops,
  setDisplayDeliveredStops,
  setDisplayUndeliveredStops,
  setDisplayPartiallyDeliveredStops,
  addDisplayedStops,
  removeDisplayedStop,
  updateStopIsChecked,
  updateAllStopsIsChecked,
  upsertSlackIssues,
} = actions;
export default reducer;
